import { useEffect, useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function NewArticle() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    title: "",
    details: "",
    photo: null, // Θα αποθηκεύσουμε το αρχείο εικόνας εδώ
  });

  useEffect(() => {
    const fetchAdminStatus = async () => {
      if (!token) {
        navigate("/");
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/get_admin_status", {
          headers: {
            "Authorization": token,
          }
        });
        if (!response.data.admin_status) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching admin status:", error);
        navigate("/");
      }
    };

    fetchAdminStatus();
  }, [token, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      photo: e.target.files[0], // Παίρνουμε το πρώτο αρχείο
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("title", formData.title); // Προσθήκη του τίτλου
    data.append("details", formData.details); // Προσθήκη του περιεχομένου του άρθρου
    if (formData.photo) {
      data.append("photo", formData.photo); // Προσθήκη της εικόνας
    }

    try {
      const response = await axios.post("https://artofbetting.gr/api/add_article", data, {
        headers: {
          "Authorization": token, // Εδώ προστίθεται το token
          "Content-Type": "multipart/form-data", // Ειδική επικεφαλίδα για αρχεία
        }
      });
      console.log("Success:", response.data);
      alert("Προστέθηκε επιτυχώς το άρθρο!");
      navigate("/articles");
    } catch (error) {
      console.error("Axios Error:", error.response ? error.response.data : error);
      alert("Κάτι πήγε στραβά, δοκίμασε πάλι!");
    }
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <header className="flex justify-between items-center p-4 bg-gray-800 mb-6 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      <h2 className="text-3xl font-bold mb-4">{translations.newArticle}</h2>

      <div className="bg-gray-800 text-white p-6 shadow-md rounded-lg">
        <form onSubmit={handleSubmit} className="grid gap-4">
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder={translations.articleTitle}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />
          <textarea
            name="details"
            value={formData.details}
            onChange={handleChange}
            placeholder={translations.articleDetails}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            rows="10"
            required
          />
          <div className="w-full px-3 py-2 rounded bg-gray-700 text-white">
            {translations.articleImage}
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>
          <button type="submit" className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
            {translations.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
